export enum SessionStorageKeys {
  XSRF_TOKEN = 'MER-XSRF-TOKEN',
}
